interface SaveSpecResponse {
  ok: boolean;
  error?: string;
}

export async function saveSpec(
  sceneKey: string,
  specType: string,
  data: object,
): Promise<SaveSpecResponse> {
  const res = await fetch('/__dev/save-spec', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sceneKey, specType, data }),
  });
  return res.json() as Promise<SaveSpecResponse>;
}

export async function saveManifest(data: object): Promise<SaveSpecResponse> {
  const res = await fetch('/__dev/save-manifest', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ data }),
  });
  return res.json() as Promise<SaveSpecResponse>;
}
